export enum EventType {
  CHRISTMAS = 'christmas',
  HALLOWEEN = 'halloween',
  AUTUMN_LEAVES = 'autumn-leaves',
  SAKURA = 'sakura',
  SONGKRAN = 'songkran',
  CHINESE_NEW_YEAR = 'chinese-new-year',
  LOY_KRATHONG = 'loy-krathong',
}

type BaseEventConfig = {
  type: EventType
}

export type StaticEventConfig = BaseEventConfig & {
  kind: 'static'
  startMonth: number // 1-12
  startDay: number
  endMonth: number // 1-12
  endDay: number
}

type DynamicEventConfig = BaseEventConfig & {
  kind: 'dynamic'
  /**
   * Function to determine if the dynamic event is active for a given date.
   */
  isActive: (date: Date) => boolean
}

export type EventConfig = StaticEventConfig | DynamicEventConfig
